import { requirePermissionGuard } from "@/shared/rbac";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

/**
 * Search params: proklik z firmy → kontakty konkrétní firmy.
 * `firmaNazev` je jen popisek pro filtr-chip. Neplatné hodnoty tiše zahodíme.
 */
const klientiSearchSchema = z.object({
  firmaId: z.string().uuid().optional().catch(undefined),
  firmaNazev: z.string().max(255).optional().catch(undefined),
});

export const Route = createFileRoute("/dashboard/klienti")({
  validateSearch: (search) => klientiSearchSchema.parse(search),
  beforeLoad: requirePermissionGuard("hca.crm.read"),
});
